<script setup>
import LogoutView from "@/components/modals/LogoutModal.vue";
import { ref, onMounted, onUnmounted } from 'vue'
import axios from 'axios'
import router from "@/router";
import store from "@/store/store";

const totalCount = ref(0)
const completedCount = ref(0)
const pendingCount = ref(0)
const requests = ref([]) // Define requests as a reactive variable

function fetchRequests() {
  axios.get("request_from_landing/")
      .then((response) => {
        requests.value = response.data.results.map((request) => ({
          id: request.id,
          name: request.name,
          phone: request.phone,
          is_resolved: request.is_resolved,
          is_faulty: request.is_faulty,
          created_datetime: request.created_datetime,
          closed_datetime: request.closed_datetime,
          is_complete: false,
        }));

        // Update counts
        totalCount.value = response.data.total_count; // Correct field for totalCount
        completedCount.value = response.data.results.filter(request => request.is_resolved).length;
        pendingCount.value = totalCount.value - completedCount.value;

        // Update localStorage and dispatch event
        const new_count = response.data.new_count; // Use new_count to update localStorage
        localStorage.setItem('requests_from_landing', new_count);
        window.dispatchEvent(new CustomEvent('landingRequestsUpdated'));
      })
      .catch((error) => {
        console.error(error);
      });
}

function handleViewRequests(){
  router.push('requests_from_landing')
}
const is_manager = ref(false)
// Set up polling
let intervalId
onMounted(() => {
  fetchRequests()
  intervalId = setInterval(fetchRequests, 30000) // Update every 30 seconds
  is_manager.value = store.getters['profile/is_manager']
})

onUnmounted(() => {
  clearInterval(intervalId)
})
</script>

<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item dropdown" v-if="is_manager">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="fas fa-inbox"></i>
          <span v-if="pendingCount > 0" class="badge badge-danger navbar-badge">{{ pendingCount }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">
            <div>Всего: {{ totalCount }} заявок</div>
            <div>Завершено: {{ completedCount }}</div>
            <div>Ожидают: {{ pendingCount }}</div>
          </span>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item" @click.prevent="handleViewRequests">
            <i class="fas fa-list mr-2"></i> Просмотреть все заявки
          </a>
        </div>
      </li>

      <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>

      <logout-view></logout-view>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>


<style scoped>

</style>